<template>
    <div v-if="isPopup" class="dialog-wrapper" @click="wrapperClick" :class="{ overlayOffset }">
        <div
            class="dialog"
            :class="{
                scrollable,
                background,
                'dialog--no-padding': noPadding,
                'dialog--no-radius': noRadius,
            }"
            @click.stop
        >
            <slot />

            <div v-if="hasCloseButton" :class="['close', closeButtonModifier]" @click="$emit('close', false)">
                <font-awesome-icon class="icon" icon="times" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Dialog',
    props: {
        isPopup: Boolean,
        padding: {
            type: Boolean,
            default: true,
        },
        overlayOffset: {
            type: Boolean,
            default: true,
        },
        background: {
            type: Boolean,
            default: true,
        },
        scrollable: {
            type: Boolean,
            default: true,
        },
        overClose: {
            type: Boolean,
            default: false,
        },
        hasCloseButton: {
            type: Boolean,
            default: true,
        },
        closeButtonModifier: {
            type: String,
            default: '',
        },
        noRadius: {
            type: Boolean,
            default: false,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        wrapperClick() {
            if (this.overClose) {
                this.$emit('close', false);
            }
        },
    },
    model: {
        event: 'close',
        prop: 'isPopup',
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';
@import '../../styles/mrem';

.dialog-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(20, 20, 20, 0.5);
    z-index: 999;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    @include on-mobile {
        padding-top: mrem(60);
    }

    .scrollable {
        overflow-y: auto;
    }

    .dialog {
        border-radius: urem(20);
        background: #ffffff;
        box-shadow: 0px 0px 16px rgba(70, 99, 171, 0.2);
        max-height: 80%;
        width: 100%;
        position: relative;
        // padding: mrem(40) mrem(16);
        padding: rem(40);
        min-width: mrem(90);

        &--no-radius {
            border-radius: 0;
        }
        &--no-padding {
            padding: 0;
        }

        @include on-desktop {
            width: fit-content;
        }

        .close {
            position: absolute;
            top: rem(18);
            right: rem(18);
            border-radius: 50%;
            background: white;
            border: rem(2.5) solid #2a2626;
            width: rem(30);
            height: rem(30);
            font-size: rem(15);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: #2a2626;
            cursor: pointer;

            @include on-mobile {
                top: mrem(10);
                right: mrem(10);
                box-shadow: 0 rem(3) rem(5) rgba(131, 134, 163, 0.12);
                border: mrem(2) solid #2a2626;
                width: mrem(25);
                height: mrem(25);
                font-size: mrem(15);
            }

            &--no-round {
                width: rem(12);
                height: rem(12);
                top: rem(26);
                right: rem(26);
                border-radius: 0;
                box-shadow: none;
                font-size: rem(21);

                &:hover {
                    color: #2a2626;
                }

                @include on-mobile {
                    width: mrem(12);
                    height: mrem(12);
                    top: mrem(16);
                    right: mrem(16);
                    border-radius: 0;
                    box-shadow: none;
                    font-size: mrem(20);

                    &:hover {
                        color: #2a2626;
                    }
                }
            }
        }
    }
    .background {
        background: #ffffff;
    }
}
.overlayOffset {
    padding: rem(44);
}
</style>
